import {
    Component,
    computed,
    inject,
    Injector,
    Input,
    OnInit,
    signal
} from '@angular/core';

import {CommonModule} from '@angular/common';

import {
    Customers,
    Printers,
    Sales,
    SalesCustomer,
    SalesPayments
} from 'tilby-models';

import {
    BarcodeEvent,
    BarcodeManagerService,
    ConfigurationManagerService,
    ConfigurationPreferences,
    EntityManagerService,
    ErrorsLoggerService,
    ToolbarEventsService
} from 'src/app/core';

import {
    AlertDialogService,
    ConfirmDialogService,
    ConfirmDialogWithRememberService,
    DocumentPrintersManagerDialogStateService,
    EInvoiceDialogService,
    ListSelectorDialogService,
    OpenDialogsService,
    OrderPrinterSelectDialogOutput,
    OrderPrinterSelectDialogService,
    PendingPrintsDialogService,
    PromptDialogService,
    PrinterErrorFiscalDialogService,
    QRCodeDialogService
} from "src/app/dialogs";

import {
    addSelectCustomerDialog,
    documentPrinter,
    fiscalUtils,
    leanPMS,
    restManager,
} from 'app/ajs-upgraded-providers';

import {GeneralInputButton} from '@tilby/tilby-ui-lib/models';

import {
    ActiveSaleService,
    ActiveSaleStoreService,
    CashregisterStateService,
    DeleteSaleOptions,
    SalePrintingUtilsService,
    SaleUtilsService,
    StoreSaleOptions
} from 'src/app/features/cashregister';

import {
    subscribeInComponent
} from "src/app/shared/angular-utils";

import {TilbyActiveSaleHeaderInfoComponent} from '@tilby/tilby-ui-lib/components/tilby-order';
import {ActiveSaleHeaderInfoV2Component} from '../active-sale-header-info-v2/active-sale-header-info-v2.component';

import {
    SelectSaleDialogService,
} from 'src/app/dialogs/cashregister';

import { ChangeSaleNameDialogService } from 'src/app/dialogs/change-sale-name-dialog';
import { DualService } from 'src/app/dual.service';
import { TranslateService } from '@ngx-translate/core';
import { AlvoloUtilsService } from 'src/app/features/settings/settings-alvolo/service';
import { DocumentPrinterOptions } from 'src/app/shared/model/document-printer.model';
import { HistoricalChangesDialogService } from 'src/app/dialogs/historical-changes-dialog/historical-changes-dialog.component';
import { MagoOrdersDialogService } from 'src/app/dialogs/cashregister';
import { TilbyDatePipe } from '@tilby/tilby-ui-lib/pipes/tilby-date';
import { TilbyCurrencyPipe } from '@tilby/tilby-ui-lib/pipes/tilby-currency';
import { SalesCustomerCashregister } from 'src/app/shared/model/cashregister.model';
import { filter } from 'rxjs';

interface PienissimoPromo {
    nome_promozione: string;
    data_scadenza: string;
    id_cliente_promozione: number;
    id_promozione: number;
    email: string;
    nome: string;
    cognome: string;
    data_create: string;
    valore_sconto: number;
    tipologia_sconto: "valore" | "percentuale";
}

interface PienissimoPrize {
    "id_premio": number,
    "punti": number,
    "premio_alternativo": string | null,
    "buono_sconto": number | null
}

interface PienissimoCustomer extends SalesCustomer {
    pienissimo_points: string 
    pienissimo_prizes?: PienissimoPrize[]
}

@Component({
    selector: 'app-active-sale-header-info-wrapper',
    standalone: true,
    imports: [
        CommonModule,
        TilbyActiveSaleHeaderInfoComponent,
        ActiveSaleHeaderInfoV2Component
    ],
    templateUrl: './active-sale-header-info-wrapper.component.html',
    styleUrls: ['./active-sale-header-info-wrapper.component.scss'],

})
export class ActiveSaleHeaderInfoWrapperComponent implements OnInit {
    private readonly activeSaleService = inject(ActiveSaleService);
    private readonly addSelectCustomerDialog = inject(addSelectCustomerDialog); // OLD DIALOG UPGRADED
    private readonly alertDialogService = inject(AlertDialogService);
    private readonly alvoloUtilsService = inject(AlvoloUtilsService);
    private readonly cashregisterStateService = inject(CashregisterStateService);
    private readonly configurationManagerService = inject(ConfigurationManagerService);
    private readonly confirmDialogService = inject(ConfirmDialogService);
    private readonly confirmDialogWithRememberService = inject(ConfirmDialogWithRememberService);
    private readonly documentPrinterService = inject(documentPrinter);
    private readonly eInvoiceDialogService = inject(EInvoiceDialogService);
    private readonly entityManagerService = inject(EntityManagerService);
    private readonly fiscalUtilsService = inject(fiscalUtils);
    private readonly injector = inject(Injector);
    private readonly leanPMS = inject(leanPMS);
    private readonly promptDialogService = inject(PromptDialogService);
    private readonly magoOrdersDialogService = inject(MagoOrdersDialogService);
    private readonly openDialogsService = inject(OpenDialogsService);
    private readonly orderPrinterSelectDialogService = inject(OrderPrinterSelectDialogService);
    private readonly pendingPrintsDialogService = inject(PendingPrintsDialogService);
    private readonly printerErrorFiscalService = inject(PrinterErrorFiscalDialogService);
    private readonly listSelectorDialogService = inject(ListSelectorDialogService);
    private readonly qrCodeDialogService = inject(QRCodeDialogService);
    private readonly restManagerService = inject(restManager);
    private readonly salePrintingUtilsService = inject(SalePrintingUtilsService);
    private readonly saleUtilsService = inject(SaleUtilsService);
    private readonly selectSaleDialogService = inject(SelectSaleDialogService);
    private readonly translateService = inject(TranslateService);
    protected readonly dualService = inject(DualService);
    private readonly historicalChangesDialogService = inject(HistoricalChangesDialogService);
    private readonly errorsLoggerService = inject(ErrorsLoggerService);
    private readonly toolbarEventsService = inject(ToolbarEventsService);

    @Input({required:true}) sale?:Sales;
    @Input({required:true}) isPaymentsState?:boolean=false;
    @Input() isMobilePortrait = false;

    documentData: string | null = null;

    protected contextMenu: GeneralInputButton[] = [];

    private country : string | undefined = undefined;

    // CONFIGURATION
    protected isAlvoloEnabled = this.alvoloUtilsService.isEnabled();

    // PERMISSIONS
    private isAddNewItemPermitted = this.configurationManagerService.isUserPermitted("cashregister.add_new_item")
    private isBillLockPermitted = this.configurationManagerService.isUserPermitted('cashregister.bill_lock');
    private isDeleteSalePermitted = this.configurationManagerService.isUserPermitted("cashregister.delete_sale");
    private isStoreSalePermitted = this.configurationManagerService.isUserPermitted("cashregister.store_sale");
    protected isOrderPrinterPermitted = this.configurationManagerService.isUserPermitted('cashregister.preorder');
    protected showPrices = this.configurationManagerService.isUserPermitted('show_prices_ui');
    protected readonly newUi = signal(this.configurationManagerService.isModuleAngular('cashregister.ui'));

    // FUNCTIONS
    private isSplitSaleEnabled = !!this.configurationManagerService.getPreference('cashregister.enable_split_sale');
    private hasPaidPayments = false;
    protected isTableNameOnTopBar : boolean = this.configurationManagerService.getPreference('cashregister.table_name_on_topbar') || false;
    protected isAccessibility : boolean = this.configurationManagerService.getPreference('general.simplified_accessibility') || false;
    protected deselectSalesFromMenuBar: boolean = this.configurationManagerService.getPreference('cashregister.deselect_sales_from_menu_bar') || false;
    protected isMagoEnabled = this.configurationManagerService.isMagoEnabled();
    protected isPienissimoEnabled = !!this.configurationManagerService.getPreference('pienissimo.token');
    protected isPienissimoFidelitiesEnabled = this.isPienissimoEnabled && !!this.configurationManagerService.getPreference('pienissimo.manage_fidelities');

    constructor() {
        subscribeInComponent(BarcodeManagerService.barcodeEvents$.pipe(
            filter((event) => !this.activeSaleService.paymentInProgress() && event.type === 'customer')
        ), (event) => this.onBarcodeCustomer(event));

        subscribeInComponent(this.dualService.currentRoute$, (currentRoute) => {
            this.isPaymentsState = currentRoute.includes("payments");
        });

        subscribeInComponent(ActiveSaleStoreService.saleUpdates$, (data) => {
            this.hasPaidPayments = data.hasPaidPayments;
            this.setContextMenu();

            if(!data.currentSale) {
                this.toolbarEventsService.events.next({ type: 'toolbar.clear_search_bar' });
            }
        }); 

        subscribeInComponent(ActiveSaleService.printerDocumentDataUpdates$, (data) => {
            this.updateDocumentType(data);
        });
    }

    ngOnInit(){
        if(this.activeSaleService.printerDocumentData) {
            this.updateDocumentType(this.activeSaleService.printerDocumentData);
        }

        this.country = this.configurationManagerService.getShopCountry();
        this.setContextMenu();
    }

    updateDocumentType(data: DocumentPrinterOptions) {
        this.documentData = this.injector.get(DocumentPrintersManagerDialogStateService).getDocumentTypeName(data, 'CASHREGISTER.ACTIVE_SALE', { excludeReceipts: true });
    }

    // HEADER INFO SECTION
    protected async selectSaleAction() {
        const res = await this.selectSaleDialogService.openDialog();

        if (!res || (res.saleId === '') ) {
            return;
        }

        await this.activeSaleService.loadSale(res.saleId);
    }

    protected async addCustomerAction() {
        this.cashregisterStateService.addCustomerAction();
    }

    protected async onBarcodeCustomer(data: BarcodeEvent) {
        //Make sure it's a customer event
        if (data.type !== 'customer') {
            return;
        }

        if (data.customer) {
            await this.cashregisterStateService.addCustomer(data.customer);

            if (this.configurationManagerService.getPreference('cashregister.use_new_add_customer_dialog')) {
                const hasEligiblePrizes = await this.checkForEligiblePrizes(data.customer);
                const askShippingAddress = this.configurationManagerService.getPreference('cashregister.ask_shipping_address');            
    
                if(data.customer.notes || data.customer.default_pricelist || askShippingAddress || hasEligiblePrizes) {
                    const currentCustomer: SalesCustomerCashregister | undefined = data.customer as SalesCustomerCashregister | undefined;
    
                    this.cashregisterStateService.openSelectCustomerDialog(currentCustomer);
                }
            }
        } else if (data.fidelity) {
            this.alertDialogService.openDialog({ data: { messageLabel: 'CASHREGISTER.SHOWCASE.NO_CLIENT_WITH_THIS_FIDELITY' } });
        } else if (data.taxCode) {
            if (this.configurationManagerService.getPreference("cashregister.on_taxcode_not_found_show_add_customer") !== false) {
                const customer = await this.addSelectCustomerDialog.show(undefined, { newCustomerData: { tax_code: data.taxCode } });
                await this.cashregisterStateService.addCustomer(customer);
            } else {
                this.activeSaleService.addTaxCode(data.taxCode);
            }
        }
    }

    async checkForEligiblePrizes(customer?: Customers) {
        const customerFidelity = customer?.fidelity;
        const now = TilbyDatePipe.date();

        if (!customerFidelity || !this.configurationManagerService.getPreference("cashregister.show_fidelity_points")) {
            return false;
        }

        const activeCampaign = await this.entityManagerService.campaigns.fetchCollectionOffline({ isValid: true })
            .then(res => res[0]);

        if (!activeCampaign) {
            return false;
        }

        const customerPoints = await this.entityManagerService.fidelitiesPoints.fetchCollectionOffline({ fidelity: customer.fidelity, campaign_id: activeCampaign.id })
            .then(res => res[0]?.points || 0);

        if (customerPoints <= 0) {
            return false;
        }

        const eligiblePrizes = await this.entityManagerService.prizes.fetchCollectionOffline({ campaign_id: activeCampaign.id })
            .then(prizes => prizes.filter((prize) => customerPoints >= prize.points &&
                (!prize.valid_from || TilbyDatePipe.compareDates(prize.valid_from.toString(), now) !== '>') && 
                (!prize.valid_to || TilbyDatePipe.compareDates(prize.valid_to.toString(), now) !== '<')
            ));

        return !!eligiblePrizes.length;
    };

    protected async removeCustomerAction() {
        if(/*$scope.isShowcase()*/ true) {
            const answer = await this.confirmDialogService.openDialog({
                data: {
                    messageLabel: 'CASHREGISTER.ACTIVE_SALE.WANT_TO_REMOVE_CLIENT'
                }
            });

            if (answer) {
                this.activeSaleService.removeCustomer();
            }
        }
    }

    private async setContextMenu() {
        const newContextMenu = await this.getContextMenu();

        // TODO: currently this works since there can be only 3 states for the context menu (no menu, mago, normal)
        // and each has a different length, improve this in the future
        if(this.contextMenu.length !== newContextMenu.length) {
            this.contextMenu = newContextMenu;
        }
    }

    // START - CONTEXT MENU FUNCTIONS
    private async getContextMenu(): Promise<GeneralInputButton[]> {
        const isLeanPMSEnabled = await this.leanPMS.isSetup();

        const documentTypeButton = {
            name: 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.DOCUMENT_TTPE',
            icon: signal('description'),
            click: () => this.showSelectPrinterDocument(),
            isIt: signal(true)
        };

        const magoOrderButton = {
            name: "CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.MAGO_ORDERS",
            icon: signal("mago"),
            click: () => this.showMagoOrders(),
            isIt: signal(this.isMagoEnabled),
            isDisable: signal(false)
        };

        const deleteSaleButton = {
            name: 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.DELETE',
            icon: signal('delete'),
            click: () => this.deleteSale(),
            isIt: signal(this.isDeleteSalePermitted),
            isDisable: () => !this.activeSaleService.isActiveSale()
        };

        if(['mago'].includes(this.activeSaleService.currentSale?.channel!)) {
            return [
                documentTypeButton,
                magoOrderButton,
                deleteSaleButton
            ];
        }

        const pienissimoButton = {
            name: "CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.PIENISSIMO",
            iconType: "svg",
            icon: signal("pienissimo"),
            click: () => this.showPienissimo(),
            isIt: signal(this.isPienissimoEnabled),
            isDisable: computed(() => !this.activeSaleService.isActiveSale())
        };

        const pienissimoFidelitiesButton = {
            name: "CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.PIENISSIMO_FIDELITIES",
            iconType: "svg",
            icon: signal("pienissimo"),
            click: () => this.showPienissimoFidelities(),
            isIt: signal(this.isPienissimoFidelitiesEnabled)
        }

        return [
            {
                name: 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.SEPARATE_BILL',
                icon: signal('call_split'),
                click: () => this.activeSaleService.splitSale(),
                isIt: () => (this.isSplitSaleEnabled && !this.hasPaidPayments && this.activeSaleService.isActiveSale())
            }, {
                name: 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.MERGE_BILLS',
                icon: signal('merge'),
                click: () => this.mergeBills(),
                isIt: signal(true),
                isDisable: () => !this.activeSaleService.isActiveSale()
            }, {
                name: 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.LOCK_SALE',
                icon: signal('lock'),
                click: () => this.activeSaleService.setLockStatus(true),
                isIt: () => this.isBillLockPermitted && this.activeSaleService.isActiveSale() && !(this.activeSaleService.currentSale?.bill_lock)
            }, {
                name: 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.UNLOCK_SALE',
                icon: signal('lock_open_right'),
                click: () => this.activeSaleService.setLockStatus(false),
                isIt: () => this.isBillLockPermitted && this.activeSaleService.isActiveSale() && !!(this.activeSaleService.currentSale?.bill_lock)
            },
                documentTypeButton, 
            {
                name: 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.BILLING_OPTIONS',
                icon: signal('receipt_long'),
                click: () => this.configureEInvoice(),
                isIt: () => this.showEInvoiceConfigMenu()
            },
            {
                name: 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.ADD_INVOICE_NOTE',
                icon: signal('receipt_long'),
                click: () => this.addInvoiceNote(),
                isIt: () => this.showEInvoiceConfigMenu()
            },
            {
                name: "CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.HOTEL_BOOKING",
                icon: signal("hotel"),
                click: () => this.showLeanHotelBooking(),
                isIt: signal(isLeanPMSEnabled),
                isDisable: () => !this.activeSaleService.isActiveSale()
            }, {
                name: "CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.QRCODE_ALVOLO",
                iconType: "svg",
                icon: signal("alvolo"),
                click: () => this.showAlvoloQrCode(),
                isIt: signal(this.isAlvoloEnabled),
                isDisable: () => !this.activeSaleService.isActiveSale()
            },
                ...(this.isMagoEnabled ? [magoOrderButton] : []),
                ...(this.isPienissimoEnabled ? [pienissimoButton]: []),
                ...(this.isPienissimoFidelitiesEnabled ? [pienissimoFidelitiesButton]: []),
            {
                name: 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.ARCHIVE',
                icon: signal('archive'),
                click: () => this.storeSale(),
                isIt: () => this.canStoreSale(),
                isDisable: () => !this.isStoreSalePermitted || !this.activeSaleService.isActiveSale() || !!this.activeSaleService.currentSale.is_summary
            }, {
                name: 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.MODIFY',
                icon: signal('edit'),
                click: () => this.modifySale(),
                isIt: signal(true),
                isDisable: () => !this.activeSaleService.isActiveSale()
            }, {
                name: 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.ADD_ROW',
                icon: signal('variable_add'),
                click: () => this.cashregisterStateService.addNewItemToSale$.next(),
                isIt: signal(this.isAddNewItemPermitted),
                isDisable: signal(this.isMagoEnabled)
            },{
                name: 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.LOTTERY_CODE',
                iconType: 'svg',
                icon: signal('lottery_code'),
                click: () => this.showAddLotteryCode(),
                isIt: () => this.activeSaleService.isActiveSale() && this.country === 'IT'
            },{
                name: 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.REPRINT_ORDER',
                icon: signal('article_shortcut'),
                click: () => this.reprintOrder(),
                isIt: () => this.activeSaleService.saleType() === 'order' && this.activeSaleService.saleMode() === 'bill'
            }, {
                name: 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.DETAILS_SALE',
                icon: signal('overview'),
                click: () => this.openEditHistoryDetail(),
                isIt: () => this.activeSaleService.isActiveSale()
            }, 
                deleteSaleButton
        ]
    }

    private canStoreSale() {
        return ['IT', 'MT'].includes(this.country!)
    }
    private showEInvoiceConfigMenu() {
        return this.activeSaleService.isActiveSale() && ['e_invoice', 'summary_e_rc', 'summary_e_nrc'].includes(`${this.activeSaleService.printerDocumentData?.document_type?.id||''}`);
    }

    private showAlvoloQrCode() {
        if(!this.isAlvoloEnabled || !this.activeSaleService.isActiveSale()) {
            return;
        }

        const baseUrl = this.alvoloUtilsService.getBaseUrl();
        const alvoloAlias = this.alvoloUtilsService.getAlias();
        const finalUrl = `${baseUrl}/${alvoloAlias}/pickup/Q-${this.activeSaleService.currentSale.uuid}/tavolo/${this.activeSaleService.currentSale.table_id || '0'}`

        //Build the header beforehand to avoid timing issues with the sale (e.g. the sale is unloaded before the QR code is printed)
        const header = [
            this.activeSaleService.currentSale.name
        ];

        if(this.activeSaleService.currentSale.table_id) {
            header.push(`${this.activeSaleService.currentSale.room_name} - ${this.activeSaleService.currentSale.table_name}`);
        }

        header.push(
            ' ',
            this.translateService.instant('CASHREGISTER.ALVOLO_QRCODE.PRINTED_TEXT')
        );

        this.qrCodeDialogService.openDialog({
            data: {
                customActions: [
                    {
                        name: '',
                        icon: signal('print'),
                        isIt: () => true,
                        click: () => this.printAlvoloQRCode(header, finalUrl)
                    }
                ],
                dialogTitle: 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.QRCODE_ALVOLO',
                qrCode: {
                    data: finalUrl,
                    width: 300,
                    errorCorrectionLevel: 'medium'
                }
            }
        });
    }

    private async showMagoOrders() {
        const sale = await this.magoOrdersDialogService.openDialog();

        if(sale) {
            this.activeSaleService.openSale(sale);
        }
    }

    async showLeanHotelBooking() {
        if(!this.activeSaleService.isActiveSale()) {
            return;
        }

        const saleInfo = await this.leanPMS.getSaleReservationData(this.activeSaleService.currentSale);

        if(!saleInfo) {
            return;
        }

        this.activeSaleService.updateSaleDetails(saleInfo);
        this.activeSaleService.saveSale();
    }

    async printAlvoloQRCode(header: string[], content: string) {
        if(!this.activeSaleService.isActiveSale()) {
            return;
        }

        const printer = await this.getTargetPrinter('alvolo.default_qrcode_printer', { printersFilter: (printer: Printers) => printer.type != 'nonfiscal' });

        if(!printer) {
            return;
        }

        await this.documentPrinterService.printFreeNonFiscal(header, printer.id, {
            barcode: {
                type: 'QRCODE',
                value: content
            }
        });
    }

    private async mergeBills() {
        if (!this.activeSaleService.isActiveSale()) {
            return;
        }

        const res = await this.selectSaleDialogService.openDialog({
            data: {
                title: 'CASHREGISTER.ACTIVE_SALE.HEADER_INFORMATION.MENU.MERGE_BILLS',
                message: 'DIALOG.SELECT_SALE_DIALOG.MERGE_BILLS_MESSAGE',
                hideCurrentSale: true,
                selectModeOnly: true
            }
        });

        if (res?.saleId) {
            await this.activeSaleService.mergeSales(res.saleId);
        }
    }

    private async deleteSale() {
        if(!this.isDeleteSalePermitted || !this.activeSaleService.isActiveSale()) {
            return;
        }

        const skipPreference = 'dialog.skip_delete.skip_question';
        const skipQuestion = this.configurationManagerService.getPreference(skipPreference);

        if (!skipQuestion) {
            const response = await this.confirmDialogWithRememberService.openDialog({
                data: {
                    textContent: 'CASHREGISTER.ACTIVE_SALE.WANT_TO_DELETE_SALE',
                    textToggle: 'CASHREGISTER.ACTIVE_SALE.REMEMBER_CHOICE',
                    classTextContent: '',
                }
            });

            if (!response.confirm) {
                return;
            }

            if(response.toggleChoice) {
                this.configurationManagerService.setUserPreference(skipPreference, true);
            }
        }

        let deleteOptions: DeleteSaleOptions | undefined;

        // check if we need to ask for a reason to delete
        if (this.configurationManagerService.getSetting('cashregister.delete_sale_needs_reason')) {
            deleteOptions = await this.saleUtilsService.askReason('delete_sale');

            // if no reason is selected, do not delete
            if (!deleteOptions) {
                return;
            }
        }

        try {
            await this.activeSaleService.deleteSale(deleteOptions);
        } catch (error: any) {
            this.alertDialogService.openDialog({ data: { messageLabel: error } });
        }
    }

    private async storeSale() {
        if (!this.canStoreSale() || !this.activeSaleService.isActiveSale()) {
            return;
        }

        const skipPreference = 'dialog.skip_archive.skip_question';
        const skipQuestion = this.configurationManagerService.getPreference(skipPreference);

        if (!skipQuestion) {
            const response = await this.confirmDialogWithRememberService.openDialog({
                data: {
                    textContent: 'CASHREGISTER.ACTIVE_SALE.WANT_TO_ARCHIVE',
                    textToggle: 'CASHREGISTER.ACTIVE_SALE.REMEMBER_CHOICE',
                    classTextContent: '',
                }
            });

            if (!response.confirm) {
                return;
            }

            if(response.toggleChoice) {
                this.configurationManagerService.setUserPreference(skipPreference, true);
            }
        }

        if(this.configurationManagerService.getPreference('cashregister.request_prebill_from_stored')) {
            const printPrebill = await this.confirmDialogService.openDialog({
                data: {
                    messageLabel: this.translateService.instant('CASHREGISTER.ACTIVE_SALE.WANT_TO_PRINT_PRE_BILL')
                }
            });
    
            if(printPrebill) {
                await this.printNonFiscalSale();
            }
        }

        let storeOptions: StoreSaleOptions | undefined;

        // check if we need to ask for a reason to store the sale
        if (this.configurationManagerService.getSetting('cashregister.store_sale_needs_reason')) {
            storeOptions = await this.saleUtilsService.askReason('store_sale');

            // if no reason is selected, do not store
            if (!storeOptions) {
                return;
            }
        }

        try {
            await this.activeSaleService.storeSale(storeOptions);
        } catch (error) {
            this.printerErrorFiscalService.openDialog({data: {error}});
        }
    }

    private async showSelectPrinterDocument() {
        let documentData = await this.injector.get(DocumentPrintersManagerDialogStateService).openDialog({ data: { documentSettings: this.activeSaleService.printerDocumentData! } });

        if(documentData) {
            this.activeSaleService.setPrinterDocumentData(documentData);
        }
    };
    private async configureEInvoice() {
        if(!this.activeSaleService.isActiveSale()) {
            return;
        }

        const salesEInvoice = await this.eInvoiceDialogService.openDialog({ data: { e_invoice: this.activeSaleService.currentSale.e_invoice || {} } });

        if(salesEInvoice) {
            this.activeSaleService.setEInvoiceData(salesEInvoice);
        }
    };

    private async addInvoiceNote() {
        if(!this.activeSaleService.isActiveSale()) {
            return;
        }
        
        const department = await this.entityManagerService.departments.fetchCollectionOffline().then(deps => deps[0]);

        if (!department) {
            return;
        }

        const note = await this.promptDialogService.openDialog({
            data: {
                title: 'CASHREGISTER.ADD_INVOICE_NOTE.TITLE',
                label: 'CASHREGISTER.ADD_INVOICE_NOTE.LABEL',
                maxLength: 255,
            }
        });

        if(!note) {
            return;
        }

        this.activeSaleService.addDynamicItemToSale(department, 0, {
            name: note,
            sku: 'invoice-note'
        });
    }

    // END - CONTEXT MENU FUNCTIONS

    private modifySale(){
        if(this.activeSaleService.isActiveSale()) {
            this.activeSaleService.editSale();
        }
    }

    async getTargetPrinter(defaultPrinterPreference: keyof ConfigurationPreferences, options?: { forceSelect?: boolean, printersFilter?: (printer: Printers) => boolean }) {
        let targetPrinter;

        const defaultPrinterId = parseInt(this.configurationManagerService.getPreference(defaultPrinterPreference) || '0', 10);

        if (defaultPrinterId && !options?.forceSelect) {
            let printer = await this.entityManagerService.printers.fetchOneOffline(defaultPrinterId);

            if (this.documentPrinterService.isPrinterUsable(printer)) {
                targetPrinter = printer;
            }
        }

        if(!targetPrinter) {
            let printers = await this.entityManagerService.printers.fetchCollectionOffline().then((printers) => printers.filter(printer => this.documentPrinterService.isPrinterUsable(printer)));

            if(options?.printersFilter) {
                printers = printers.filter(options.printersFilter);
            }

            const dialogOutput: OrderPrinterSelectDialogOutput | undefined  = await this.orderPrinterSelectDialogService.openDialog({ data: { printers, defaultPrinterId: defaultPrinterId, enableSetAsDefault: true } });
            targetPrinter = dialogOutput?.selectedPrinter;
            const setAsDefault = dialogOutput?.setAsDefault;

            if(!targetPrinter) {
                return;
            }

            if (setAsDefault) {
                this.configurationManagerService.setUserPreference(defaultPrinterPreference, targetPrinter.id?.toString() || '0');
            }
        }

        return targetPrinter;
    }

    protected async printNonFiscalSale(forceSelect? : boolean) {
        await this.activeSaleService.checkSaleConfirm(true);

        const targetPrinter = await this.getTargetPrinter('cashregister.nonfiscalsale_default_printer', { forceSelect });

        if(!targetPrinter) {
            return;
        }

        //Send the sale to the printer
        try {
            await this.activeSaleService.printNonFiscalSale(targetPrinter);

            this.openDialogsService.openSnackBarTilby('CASHREGISTER.ACTIVE_SALE.NON_FISCAL_SALE_PRINTED', 'MISC.OK', { duration: 3000 });
        } catch(error) {
            this.printerErrorFiscalService.openDialog({data: {error, options: {printerId: targetPrinter.id}}});
            throw error;
        }
    }

    private async reprintOrder() {
        const results = await this.activeSaleService.reprintOrder();

        if(this.salePrintingUtilsService.getPrintErrors(results).length) {
            this.pendingPrintsDialogService.openDialog();
        }
    }

    async openEditHistoryDetail() {
        try {
            const [sale, transactions] = this.activeSaleService.getSaleChangesDetails({ includeCurrentChanges: false });

            if(sale && transactions) {
                await this.historicalChangesDialogService.openDialog({data: {title: 'HISTORY.TRANSACTIONS_VIEWER.TITLE', transactions, sale}});
            } else {
                return;
            }

        } catch (err) {
            this.errorsLoggerService.err(err);
        }
    }

    async saleChangeName() {
        const res = await this.injector.get(ChangeSaleNameDialogService).openDialog({saleName: this.activeSaleService.currentSale.name});

        if (!res?.saleName) {
            return;
        }

        await this.activeSaleService.saveSale(res.saleName, true);
    }

    async deselectSaleAction() {
        await this.activeSaleService.loadSale(undefined);
    }

    async showPienissimo() {
        if(!this.activeSaleService.isActiveSale()) {
            return;
        }

        const sale = structuredClone(this.activeSaleService.currentSale);

        if(!sale.sale_items?.length) {
            this.alertDialogService.openDialog({ data: { messageLabel: 'CASHREGISTER.ACTIVE_SALE_MODEL.NO_ITEM_IN_SALE' } });
            return;
        }

        await this.activeSaleService.saveSale();

        const code = await this.promptDialogService.openDialog({
            data: {
                title: 'CASHREGISTER.PIENISSIMO_DIALOG.TITLE',
                label: 'CASHREGISTER.PIENISSIMO_DIALOG.INPUT',
                allowCamera: true
            }
        });

        if(!code) {
            return;
        }

        try {
            const promo: PienissimoPromo = await this.restManagerService.post('pienissimo/qr_check', {
                customerId: this.activeSaleService.currentSale?.sale_customer?.external_id,
                codice: code,
                sale: sale
            });
            
            if(!promo) {
                return;
            }
            
            const discountValueString = promo.tipologia_sconto === 'valore'
                ? this.injector.get(TilbyCurrencyPipe).transform(promo.valore_sconto || 0)
                : `${promo.valore_sconto} %`;

            const confirm = await this.confirmDialogService.openDialog({
                data: {
                    titleLabel: 'CASHREGISTER.PIENISSIMO_DIALOG.CONFIRM_APPLY',
                    messageLabel: [
                        ``,
                        `${this.translateService.instant('CASHREGISTER.PIENISSIMO_DIALOG.PROMOTION')}: ${promo.nome_promozione}`,
                        `${this.translateService.instant('CASHREGISTER.PIENISSIMO_DIALOG.TYPE')}: ${promo.tipologia_sconto}`,
                        `${this.translateService.instant('CASHREGISTER.PIENISSIMO_DIALOG.DISCOUNT')}: ${discountValueString}`,
                    ].join('\n')
                }
            });

            if(!confirm) {
                return;
            }

            //Check if the discount can actually be applied before consuming the QR Code
            if(promo.tipologia_sconto === 'valore') {
                const discountableAmount = this.fiscalUtilsService.getDiscountableAmount(this.activeSaleService.currentSale);

                if(promo.valore_sconto > discountableAmount) {
                    const translation = this.translateService.instant(`CASHREGISTER.ACTIVE_SALE_MODEL.DISCOUNT_TOO_HIGH`, { amount: this.injector.get(TilbyCurrencyPipe).transform(discountableAmount) });

                    this.alertDialogService.openDialog({ data: { messageLabel: translation } });
                    return;
                }
            }

            await this.restManagerService.post('pienissimo/qr_consume', {
                customerId: this.activeSaleService.currentSale?.sale_customer?.external_id,
                codice: code
            });

            const ruleName = `pienissimo_${promo.id_promozione}`;
    
            switch(promo.tipologia_sconto) {
                case 'valore':
                    this.activeSaleService.addSaleDiscountFix(promo.valore_sconto, promo.nome_promozione, undefined, { rule_name: ruleName });
                    break;
                case 'percentuale':
                    this.activeSaleService.addSaleDiscountPerc(promo.valore_sconto, promo.nome_promozione, undefined, { rule_name: ruleName });
                    break;
            }
    
            this.activeSaleService.saveSale();
        } catch(err: any) {
            if(err?.data?.error?.detail) {
                this.alertDialogService.openDialog({ data: { messageLabel: err.data.error.detail } });
            }
        }
    }

    async showPienissimoFidelities() {
        const searchTarget = <string>await this.promptDialogService.openDialog({
            data: {
                title: 'CASHREGISTER.PIENISSIMO_DIALOG.TITLE_FIDELITY',
                label: 'CASHREGISTER.PIENISSIMO_DIALOG.INPUT',
                allowCamera: true
            }
        });

        if (!searchTarget) {
            return;
        }

        const searchPayload = searchTarget.startsWith('+')
            ? { telefono: searchTarget }
            : { qrcode: searchTarget }

        try {
            const response = await this.restManagerService.post('pienissimo/fidelity_check', searchPayload) as PienissimoCustomer | SalesPayments;

            if ('payment_method_type_id' in response) {
                const giftcardMethodId = Number(this.configurationManagerService.getPreference('pienissimo.giftcard_method'));

                if(!giftcardMethodId) {
                    this.alertDialogService.openDialog({
                        data: {
                            messageLabel: 'CASHREGISTER.PIENISSIMO_DIALOG.NO_GIFTCARD_METHOD'
                        }
                    });

                    return;
                }

                const giftcardMethod = await this.entityManagerService.paymentMethods.fetchOneOffline(giftcardMethodId);

                if(!giftcardMethod) {
                    this.alertDialogService.openDialog({
                        data: {
                            messageLabel: 'CASHREGISTER.PIENISSIMO_DIALOG.NO_GIFTCARD_METHOD'
                        }
                    });

                    return;
                }

                const amountString = this.injector.get(TilbyCurrencyPipe).transform(response.amount);

                const dataToShow: { field: string, value: string }[] = [
                    { field: `${this.translateService.instant('CASHREGISTER.PIENISSIMO_DIALOG.AMOUNT')}`, value: amountString }
                ];

                const confirm = await this.confirmDialogService.openDialog({
                    data: {
                        titleLabel: 'CASHREGISTER.PIENISSIMO_DIALOG.CONFIRM_GIFTCARD_APPLY',
                        messageLabel: dataToShow.map((row) => `<div>${row.field}: <span class="tw-font-bold">${row.value}</span></div>`).join(''),
                        isHtml: true,
                        customStyle: {
                            'font-size': '1.625rem',
                            'line-height': '2rem',
                            'padding-top': '1rem'
                        }
                    }
                });

                if (!confirm) {
                    return;
                }

                const payment: Partial<SalesPayments> = {
                    ...response,
                    payment_method_id: giftcardMethod.id,
                    payment_method_name: giftcardMethod.name,
                };

                // the giftcard is applied as a payment: there must be a sale to attach it to
                if (!this.activeSaleService.isActiveSale()) {
                    await this.activeSaleService.createNewSale();
                }

                const currentPayments = this.activeSaleService.currentSale.payments || [];

                if(currentPayments.some(p => p.acquirer_name === 'pienissimo_giftcard')) {
                    this.alertDialogService.openDialog({
                        data: {
                            messageLabel: 'CASHREGISTER.PIENISSIMO_DIALOG.GIFTCARD_ALREADY_APPLIED'
                        }
                    });

                    return;
                }

                this.activeSaleService.updateSaleDetails({
                    payments: [...currentPayments, payment as SalesPayments]
                });

                this.activeSaleService.saveSale();
            } else {
                const saleCustomer = response;

                const dataToShow: { field: string, value: string }[] = [
                    { field: `${this.translateService.instant('CASHREGISTER.PIENISSIMO_DIALOG.FIDELITY_NAME')}`, value: saleCustomer.custom_type! },
                    { field: `${this.translateService.instant('CUSTOMERS.SHOWCASE.FIRST_NAME')}`, value: saleCustomer.first_name! },
                    { field: `${this.translateService.instant('CUSTOMERS.SHOWCASE.LAST_NAME')}`, value: saleCustomer.last_name! },
                ];

                if (saleCustomer.email) {
                    dataToShow.push({ field: `${this.translateService.instant('CUSTOMERS.SHOWCASE.EMAIL')}`, value: saleCustomer.email });
                }

                if (saleCustomer.pienissimo_points != null) {
                    dataToShow.push({ field: `${this.translateService.instant('CUSTOMERS.DETAILS.SUMMARY.POINTS')}`, value: saleCustomer.pienissimo_points });
                }

                const confirm = await this.confirmDialogService.openDialog({
                    data: {
                        titleLabel: 'CASHREGISTER.PIENISSIMO_DIALOG.CONFIRM_FIDELITY_APPLY',
                        messageLabel: dataToShow.map((row) => `<div>${row.field}: <span class="tw-font-bold">${row.value}</span></div>`).join(''),
                        isHtml: true,
                        customStyle: {
                            'font-size': '1.625rem',
                            'line-height': '2rem',
                            'padding-top': '1rem'
                        }
                    }
                });

                if (!confirm) {
                    return;
                }

                await this.activeSaleService.updateSaleCustomer(saleCustomer);

                // persist the customer before the optional prize step, which can fail
                this.activeSaleService.saveSale();

                // Check if there are prizes
                const fidelityId = response.external_id?.split('-')[0];

                if(fidelityId && response.pienissimo_prizes?.length) {
                    const prizesList = response.pienissimo_prizes.map((prize) => ({
                        id: prize.id_premio,
                        name: prize.buono_sconto
                            ? this.translateService.instant('CASHREGISTER.PIENISSIMO_DIALOG.DISCOUNT_PRIZE', { value: prize.buono_sconto, points: prize.punti })
                            : this.translateService.instant('CASHREGISTER.PIENISSIMO_DIALOG.ALTERNATIVE_PRIZE', { name: prize.premio_alternativo, points: prize.punti })
                    }));

                    prizesList.unshift({
                        id: -1,
                        name: this.translateService.instant('CASHREGISTER.PIENISSIMO_DIALOG.NO_PRIZE')
                    });

                    const selectedPrize = await this.listSelectorDialogService.openDialog<{ id: number, name: string }>({
                        data: {
                            optionList: prizesList,
                            optionValue: prizesList[0],
                            title: 'CASHREGISTER.PIENISSIMO_DIALOG.SELECT_PRIZE',
                            searchable: false
                        }
                    });

                    if(selectedPrize?.id && selectedPrize?.id !== -1) {
                        await this.restManagerService.post('pienissimo/reclaim_prize', {
                            "id_premio": selectedPrize.id,
                            "fidelity_id": fidelityId
                        });

                        this.openDialogsService.openSnackBarTilby('CASHREGISTER.PIENISSIMO_DIALOG.PRIZE_RECLAIMED', 'MISC.OK');
                    }
                }
            }
        } catch (err: any) {
            this.alertDialogService.openDialog({
                data: { messageLabel: err?.data?.message ?? 'APPLICATION.PRINTER_ERROR_FISCAL.UNKNOWN_ERROR' }
            });
        }
    }

    async showAddLotteryCode() {
        const oldLotteryCode = this.activeSaleService.currentSale.lottery_code;

        const res = await this.promptDialogService.openDialog({
            data: {
                minLength: 8,
                maxLength: 8,
                value: oldLotteryCode,
                title: 'CASHREGISTER.LOTTERY_CODE_DIALOG.TITLE',
                label: 'CASHREGISTER.LOTTERY_CODE_DIALOG.INPUT',
                allowCamera: true
            }
        });

        if (typeof res !== 'string') {
            return;
        }

        const lotteryCode = res.toUpperCase();

        this.activeSaleService.updateSaleDetails({ lottery_code: lotteryCode });

        const customerId  = this.activeSaleService.currentSale?.sale_customer?.customer_id;

        if(customerId && oldLotteryCode !== lotteryCode) {
            const answer = await this.confirmDialogService.openDialog({
                data: {
                    messageLabel: 'APPLICATION.ADD_SELECT_CUSTOMER.CONFIRM_LOTTERY_CODE_CHANGE'
                }
            });

            if(answer) {
                let customer = await this.entityManagerService.customers.fetchOneOfflineFirst(customerId);
                if (customer) {
                    customer.lottery_code = lotteryCode;
                    this.entityManagerService.customers.putOneOfflineFirst(customer);
                }
            }
        }
    };
}
